import React from 'react';
import {hoc} from 'Page/Sections/BlogPreview/BlogPreview';
import {File as FWFile} from 'FW/Models/File';
import _ from 'underscore';

class BlogPreviewList extends React.Component {
  render() {
    let posts = this.props.posts.map(post => {
      let backgroundUrl;
      let imageId = post.get('thumbnail_image')
        ? post.get('thumbnail_image')
        : post.get('featured_image');
      if (imageId) {
        let background = FWFile.findOrCreate({id: imageId});
        backgroundUrl = background.helper.thumbnailUrl(800);
      } else {
        backgroundUrl = null;
      }
      const opts = this.props.section.prop('basic_options') || {};

      let styleDefaults = {
        height: '230px',
        minWidth: '230px',
        display: 'block',
        backgroundSize: opts.background_size || 'cover',
        backgroundPosition: opts.background_position || 'center',
        backgroundRepeat: 'no-repeat'
      };
      let style = backgroundUrl
        ? _.defaults(styleDefaults, {
            backgroundImage: 'url(' + backgroundUrl + ')'
          })
        : styleDefaults;
      let advancedOptions =
        this.props.section.get('properties').advanced_options || {};

      return (
        <div key={'post-' + post.get('id')} className="col-md-12">
          <div className="thumbnail col-md-12">
            <a href={post.getUrl()} style={style} className="col-md-4" />
            <div className="caption col-md-8">
              <h3>
                <a href={post.getUrl()}>{post.get('title')}</a>
              </h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: post.getPreview(advancedOptions.characters_to_display, opts.show_all_line_breaks)
                }}
              ></p>
              <a href={post.getUrl()} className="btn btn-default" role="button">
                Read More
              </a>
            </div>
          </div>
        </div>
      );
    });

    return <span className="col-md-12">{posts}</span>;
  }
}

export default hoc(BlogPreviewList);
